import React from 'react';
import Layout from '../components/includes/Layout';
import Team from '../components/teams/team';
import {
    teamsApi,
    useGetTeamsQuery,
} from "../features/teams/teamsApi";
import { useSelector } from "react-redux";
import TeamItem from '../components/teams/teamItem';
const Teams = () => {
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const { data, isLoading, isError, error } = useGetTeamsQuery(loggedInUser.id) || {};

    
  return (

      <Layout>
        <Team/>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto p-5">
          {isLoading && 
           <h2 className=' text-center '> Loading . . .</h2>
          }
          {data && data.length >0 && data.map((item,i)=>(
            
              <TeamItem key={i} item={item} />
            
          ))
         }
        </div>
      

      </Layout>

  )
}

export default Teams